import { makeStyles } from "@material-ui/core";

export const useCommonTableStyles = makeStyles((theme: any) => ({
  // Search and filter container
  searchContainer: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    marginBottom: "20px",
  },

  // Search bar input
  searchBar: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "404px",
    height: "45px",
    "& .MuiOutlinedInput-root": {
      height: "45px",
      borderRadius: "8px",
      fontFamily: "DM Sans",
      fontSize: "14px",
      fontWeight: 500,
      padding: "8px 9px",
      "& fieldset": {
        borderColor: "#000000",
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: "#000000",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000 !important",
        borderWidth: "2px",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000000 !important",
        borderWidth: "2px",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000000",
    },
    "& .MuiOutlinedInput-input": {
      fontFamily: "DM Sans",
      fontSize: "14px",
      fontWeight: 500,
      color: "#000",
      padding: "0",
      "&::placeholder": {
        color: "var(--search-placeholder-color, #9E9E9E)",
        opacity: 1,
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none",
    },
  },

  // Filter select dropdown
  filterSelect: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "auto",
    minWidth: "180px",
    "&:focus, &:focus-visible": {
      outline: "none",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#000000",
      },
      "&:hover fieldset": {
        borderColor: "#000000",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000 !important",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000000 !important",
      },
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000000 !important",
    },
    "& .MuiSelect-select": {
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingRight: "32px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    "& .MuiSelect-icon": {
      display: "none",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
      borderColor: "#000000 !important",
    },
  },

  // Header content wrapper (for icon + text)
  headerContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  // Sort icon
  sortIcon: {
    width: "16px",
    height: "16px",
    display: "inline-block",
  },
}));

// Header cell inline styles
export const headerCellStyle = {
  fontWeight: 700,
  fontSize: "16px",
  fontFamily: "DM Sans",
  padding: "10px 12px",
  verticalAlign: "top" as const,
  backgroundColor: "#FFFFFF",
  color: "#000000",
  whiteSpace: "normal" as const,
  borderTop: "1px solid #E8E8E8",
  borderBottom: "1px solid #E8E8E8",
  userSelect: "none" as const,
  wordWrap: "break-word" as const,
  "@media (max-width: 1500px)": {
    fontSize: "14px",
    padding: "8px 10px",
  },
  "@media (max-width: 1400px)": {
    fontSize: "13px",
    padding: "7px 8px",
  },
  "@media (max-width: 1200px)": {
    fontSize: "12px",
    padding: "6px 6px",
  },
  "@media (max-width: 1024px)": {
    fontSize: "11px",
    padding: "5px 4px",
  },
};

// Body cell inline styles
export const bodyCellStyle = {
  fontSize: "15px",
  fontFamily: "DM Sans",
  fontWeight: 500,
  color: "#000",
  padding: "12px 10px",
  borderBottom: "1px solid #E8E8E8",
  "@media (max-width: 1500px)": {
    fontSize: "14px",
    padding: "10px 8px",
  },
  "@media (max-width: 1400px)": {
    fontSize: "13px",
    padding: "8px 6px",
  },
  "@media (max-width: 1200px)": {
    fontSize: "12px",
    padding: "7px 5px",
  },
  "@media (max-width: 1024px)": {
    fontSize: "11px",
    padding: "6px 4px",
  },
};

// Get row background color based on index (alternating)
export const getRowBackgroundColor = (index: number): string => {
  return index % 2 === 0 ? "#FFFFFF" : "#F4F4F4";
};

// Paper container styles
export const paperStyles = {
  width: "100%",
  overflow: "hidden",
  borderRadius: "12px",
  boxShadow: "none",
  border: "1px solid #E8E8E8",
  backgroundColor: "#ffffff",
};

// Table container styles
export const tableContainerStyles = {
  maxHeight: "80vh",
  backgroundColor: "#ffffff",
  overflowX: "auto" as const,
  "&::-webkit-scrollbar": {
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
};

// Default row height
export const DEFAULT_ROW_HEIGHT = 91;
